import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './index.css';
import { AuthProvider } from './context/AuthContext';
import Welcome from './components/welcome/Welcome';
import UserRegistration from './components/auth/UserRegistration';
import Login from './components/auth/Login';
import RecruiterLogin from './components/auth/RecruiterLogin';
import Dashboard from './components/dashboard/user/Dashboard';
import RecruiterDashboard from './components/dashboard/recruiter/RecruiterDashboard';
import PersonalInfo from './components/profile/PersonalInfo';
import AddressDetails from './components/profile/AddressDetails';
import Education from './components/profile/Education';
import Skills from './components/profile/Skills';
import ProtectedRoute from './components/common/ProtectedRoute';
import { ThemeProvider } from './context/ThemeContext';
import ThemeToggle from './components/common/ThemeToggle';
import TestResults from './components/mock-test/TestResults';
import AptitudeTest from './components/aptitude/AptitudeTest';
import LogicalTest from './components/logical/LogicalTest';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Welcome />} />
            <Route path="/register" element={<UserRegistration />} />
            <Route path="/login" element={<Login />} />
            <Route path="/recruiter-login" element={<RecruiterLogin />} />
            <Route path="/dashboard/recruiter" element={<RecruiterDashboard />} />
            {/* Profile Routes */}
            <Route path="/profile/personal" element={
              <ProtectedRoute>
                <PersonalInfo />
              </ProtectedRoute>
            } />
            <Route path="/logical-test/:jobId" element={
  <ProtectedRoute requiredRole="candidate">
    <LogicalTest />
  </ProtectedRoute>
} />
            <Route path="/aptitude-test/:jobId" element={<AptitudeTest />} />
            <Route path="/profile/address" element={
              <ProtectedRoute>
                <AddressDetails />
              </ProtectedRoute>
            } />
            <Route path="/profile/education" element={
              <ProtectedRoute>
                <Education />
              </ProtectedRoute>
            } />
            <Route path="/profile/skills" element={
              <ProtectedRoute>
                <Skills />
              </ProtectedRoute>
            } />
            {/* Dashboard Routes */}
            <Route path="/dashboard/user" element={
              <ProtectedRoute requiredRole="candidate">
                <Dashboard />
              </ProtectedRoute>
            }>
              <Route path="test-results" element={<TestResults />} />
            </Route>

            <Route path="/dashboard/recruiter" element={
              <ProtectedRoute requiredRole="recruiter">
                <RecruiterDashboard />
              </ProtectedRoute>
            } />

            {/* Catch all undefined routes */}
            <Route path="*" element={<Navigate to="/profile/personal" />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <ThemeToggle />
    </ThemeProvider>
  );
}

export default App;
